import * as IMG from '@Utils/Images';

export default [
  {
    image: IMG.ABOUT_1,
    name: 'Irham Muhammad Shidiq',
    position: 'Ketua',
    desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque repellat quae ea quam corporis.',
    address: 'Bogor',
    linkedin: 'https://www.linkedin.com/in/irham-muhammad-shidiq/',
    github: 'https://github.com/xevorte',
    instagram: 'https://www.instagram.com/irham.ms_/',
  },
  {
    image: IMG.ABOUT_2,
    name: 'Fitra Ari Pradhana',
    position: 'Anggota',
    desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque repellat quae ea quam corporis.',
    address: 'Bandung',
    linkedin: '',
    github: '',
    instagram: 'https://www.instagram.com/fitraari3/',
  },
  {
    image: IMG.ABOUT_3,
    name: 'Dewi Saraswati',
    position: 'Anggota',
    desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque repellat quae ea quam corporis.',
    address: 'Bekasi',
    linkedin: 'https://www.linkedin.com/in/dewi-saraswati/',
    github: '',
    instagram: '',
  },
  {
    image: IMG.ABOUT_4,
    name: 'Ade Daud Hasan',
    position: 'Anggota',
    desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque repellat quae ea quam corporis.',
    address: 'Majalengka',
    linkedin: '',
    github: '',
    instagram: 'https://www.instagram.com/adedaudhasan/',
  },
  {
    image: IMG.ABOUT_5,
    name: 'Ade Ilham',
    position: 'Anggota',
    desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque repellat quae ea quam corporis.',
    address: 'Bogor',
    linkedin: 'https://www.linkedin.com/in/ade-ilham',
    github: '',
    instagram: '',
  },
];